import './setBuildKey';
import './defaultConfig';
import 'common/build/services/useClientSideApi';

import ReactDOM from 'react-dom';
import { PortalProviders, portalUserService } from 'common';

import App from './App';
import { routes } from './signup-portal.routes';
import { clearSignInState } from './pages/Supplier/PostSignup/useSilentSignIn';

// The portal is unauthenticated; tokens left behind by an abandoned
// post-signup session are stale and poison the shared API interceptors.
clearSignInState();

// Don't inherit Manager/supplier brand from localStorage; signup brand is per-buyer CSP.
portalUserService.clearBrandVersion();

const appRoot = document.getElementById('root')!;

ReactDOM.render(
    <PortalProviders rootUrl={''} routes={routes}>
        <App />
    </PortalProviders>,
    appRoot
);
